const coordinates = {
	cardinal: function(coordinates) {
		let cardinalCoordinates = {}
		let deg = String.fromCharCode(176);
		const trimLatLng = this.trimToNearest(coordinates, 2);
		let lat = Math.abs(trimLatLng[0]);
		let lon = Math.abs(trimLatLng[1]);
		cardinalCoordinates.lat = (coordinates[0] >= 0) ? `${lat}${deg}N` : `${lat}${deg}S`;
		cardinalCoordinates.lon = (coordinates[1] >= 0) ? `${lon}${deg}E` : `${lon}${deg}W`;
		return cardinalCoordinates;
	},
	match: function(coordinatesOne, coordinatesTwo) {
	  const marginError = 0.00011;
	  const lng = Math.abs(Number(coordinatesOne[0]).toFixed(4) - Number(coordinatesTwo[0]).toFixed(4)) < marginError;
	  const lat = Math.abs(Number(coordinatesOne[1]).toFixed(4) - Number(coordinatesTwo[1]).toFixed(4)) < marginError;
	  return lng && lat;
	},
	trimToNearest: function(coordinates, decimalPlace) {
		for (var i = 0; i < coordinates.length; i++){
			if (coordinates[i] % 1 !== 0 && !isNaN(coordinates[i])) {
				const point = coordinates[i].toString().split('.');
				coordinates[i] = Number(`${point[0]}.${point[1].substring(0, decimalPlace)}`);
			}
		}
		return coordinates;
	}
};

export default coordinates;



// WEBPACK FOOTER //
// ./src/utils/coordinates.js